import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-scenario-three',
	templateUrl: './scenario-three.component.html',
	styleUrls: ['./scenario-three.component.scss']
})
export class ScenarioThreeComponent {
	personalId;
	scenarioThreeForm: FormGroup;

	personalIdNumbers = [];

	constructor(
		private formBuilder: FormBuilder,
		private router: Router,
		private route: ActivatedRoute
	) {
		this.scenarioThreeForm = this.createScenarioThreeForm();
	}

	ngOnInit() {
		this.personalId = this.route.queryParams.subscribe(params => {
			this.personalId = +params['personalId'] || 0;
		});
	}

	navigateToResults() {
		let object = '';

		this.personalIdNumbers.forEach((idNumber, index) => {
			object += ',' + idNumber;
		});

		this.router.navigate(['/scenario-three-results/' + object]);
	}

	createScenarioThreeForm() {
		return this.formBuilder.group({
			personalIdNumbers: this.formBuilder.array([])
		});
	}

	trim(item: string) {
		return item.trim() === '';
	}

	onAddPersonalId(personalId) {
		if (!this.trim(personalId)) {
			this.personalIdNumbers.push(personalId);
		}
	}

	createPersonalIdItem(personalIdName) {
		return this.formBuilder.group({
			name: [personalIdName]
		});
	}

	get getPersonalIdItems(): FormArray {
		return <FormArray>this.scenarioThreeForm.controls.personalId;
	}

	deletePersonalIdItem(index: number) {
		(this.scenarioThreeForm.get('personalIdNumbers') as FormArray).removeAt(
			index
		);
	}
}
